import { type ReactNode } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import classnames from 'classnames';

import { Image, PaymentPill } from '@jsmdg/yoshi';
import { PaymentMethod } from '../../../shared/enums/paymentMethods';
import { paymentMethodLogoMap } from './paymentMethodLogoMap';
import styles from './PaymentMethods.module.scss';

const messages = defineMessages({
    paymentTypeInvoice: {
        defaultMessage: 'Rechnung',
    },
});

type Props = {
    readonly enabledMethods: PaymentMethod[];
    readonly className?: string;
};

const PaymentMethods = ({ className, enabledMethods }: Props): JSX.Element => {
    const intl = useIntl();

    return (
        <div>
            <div id="payment-methods" className={classnames('pt-2x', 'pl-2-5x ')}>
                <ul className={classnames('d-flex flex-wrap p-0', styles.listWrapper, className)}>
                    {enabledMethods.map(
                        (method): ReactNode => (
                            <li key={method} className="mb-2x mx-sm-1x mx-0-5x">
                                <PaymentPill text={method === PaymentMethod.Invoice}>
                                    {method === PaymentMethod.Invoice ? (
                                        <span>
                                            {intl.formatMessage(messages.paymentTypeInvoice)}
                                        </span>
                                    ) : (
                                        <Image
                                            alt={paymentMethodLogoMap[method].alt}
                                            src={paymentMethodLogoMap[method].icon}
                                            className={styles.small}
                                            loading="lazy"
                                        />
                                    )}
                                </PaymentPill>
                            </li>
                        ),
                    )}
                </ul>
            </div>
        </div>
    );
};

export { PaymentMethods };
